import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { PageHeader } from '../../components/layout/PageHeader';
import { useCurrentUser } from '../auth';
import { AccountList } from './AccountList';
import { AccountsGrid } from './AccountsGrid';

// Stage 5A §3.1 — the /accounts page hosts two views: the new filterable Grid
// (default) and the existing hierarchy Tree. A toggle switches between them;
// both share this page's title + New-account button.

type View = 'grid' | 'tree';

export function AccountsPage() {
  const user = useCurrentUser();
  const [view, setView] = useState<View>('grid');

  return (
    <div>
      <PageHeader
        title="Accounts"
        description="Every client relationship, at every hierarchy level."
        actions={
          <>
            <div className="inline-flex rounded-md border border-slate-300 overflow-hidden text-sm">
              <ToggleButton active={view === 'grid'} onClick={() => setView('grid')}>
                Grid
              </ToggleButton>
              <ToggleButton active={view === 'tree'} onClick={() => setView('tree')}>
                Tree
              </ToggleButton>
            </div>
            {user.role === 'admin' && (
              <Button asChild>
                <Link to="/accounts/new">New account</Link>
              </Button>
            )}
          </>
        }
      />

      {view === 'grid' ? <AccountsGrid /> : <AccountList embedded />}
    </div>
  );
}

function ToggleButton({
  active,
  onClick,
  children,
}: {
  active: boolean;
  onClick: () => void;
  children: React.ReactNode;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={active}
      className={`px-3 py-1.5 ${active ? 'bg-slate-800 text-white' : 'bg-white text-slate-700 hover:bg-slate-50'}`}
    >
      {children}
    </button>
  );
}
